import { render, staticRenderFns } from "./HeaderStep.vue?vue&type=template&id=543bd0fa&"
import script from "./HeaderStep.vue?vue&type=script&lang=js&"
export * from "./HeaderStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports